/* Felicitations Quote Calculator v2 - Studio Intake direction
 *
 * Single-page intake card with live-updating estimate.
 * Real pricing via window.FEL_PRICING (quote-pricing.js) - defaults per Masha 2026-05-23.
 */
(function() {
  'use strict';

  var state = {
    coupleNames: '',
    email: '',
    weddingDate: '',
    location: '',
    guestCount: '',
    categories: { std: false, inv: false, otd: false },
    selectedCategory: '',
    std: { on: false, qty: 0, checks: {} },
    inv: { on: false, qty: 0, checks: {} },
    otd: { on: false, items: {} },
    des: { type: '', checks: {} },
    requestSample: false
  };

  window.FEL_V2 = window.FEL_V2 || {};
  window.FEL_V2.state = state;

  // ── Image rendering ──────────────────────────────────────────
  // Clean entry (no URL tier/design params) → ARUL placeholder image.
  // Direct entry from a product/collection page → image hidden entirely
  // (the customer already saw the product photo; no need to duplicate).
  var DEFAULT_PLACEHOLDER_IMAGE = 'https://felicitations.com.au/cdn/shop/files/ARUL_NIC_SNIPPET_001.webp?v=1749109672&width=1200';

  function setIntakeImage(url, caption) {
    var fig = document.getElementById('intakeImage');
    var img = document.getElementById('intakeImageImg');
    var cap = document.getElementById('intakeImageCaption');
    if (!fig || !img || !cap) return;
    if (!url) {
      fig.hidden = true;
      img.src = '';
      cap.textContent = '';
      return;
    }
    fig.hidden = false;
    img.src = url;
    cap.textContent = caption || '';
  }

  function refreshIntakeImage() {
    if (state.des.fromUrl) {
      // Direct entry (product page deep-link) - hide image
      setIntakeImage('', '');
      return;
    }
    // Clean entry - show ARUL placeholder
    setIntakeImage(DEFAULT_PLACEHOLDER_IMAGE, '');
  }
  window.FEL_V2.setIntakeImage = setIntakeImage;

  function fmt0(n) {
    return '$' + Math.round(n).toLocaleString('en-AU');
  }

  // ── URL parameter hydration ───────────────────────────────────
  function readUrlParams() {
    var p = new URLSearchParams(window.location.search);
    var tier = (p.get('tier') || '').toLowerCase();
    var designHandle = p.get('design') || p.get('suite') || '';
    var designName = p.get('name') || '';
    var designImage = p.get('image') || '';

    if (['suite', 'indiv', 'bespoke'].indexOf(tier) >= 0) {
      state.des.type = tier;
      state.des.fromUrl = true;
    }
    if (designHandle) {
      state.des.designHandle = designHandle;
      if (!tier && !state.des.type && p.get('suite')) {
        state.des.type = 'suite';
        state.des.fromUrl = true;
      }
    }
    if (designName) state.des.designName = designName;
    if (designImage) state.des.designImage = designImage;
  }

  // ── Field handlers ────────────────────────────────────────────
  function onGuestInput(val) {
    state.guestCount = String(val).replace(/[^0-9]/g, '');
    var n = parseInt(state.guestCount, 10) || 0;
    var hint = document.getElementById('bpInviteHint');
    if (hint) {
      if (n > 0) hint.textContent = ' · ~' + Math.ceil(n * 0.6) + ' invitations';
      else hint.textContent = '';
    }
    recompute();
  }

  function selectScope(scope) {
    state.selectedCategory = scope;
    state.categories = {
      std: scope === 'full',                    // STD only included for full scope (Masha 2026-05-23)
      inv: scope === 'full' || scope === 'inv-std',
      otd: scope === 'full' || scope === 'otd'
    };
    document.querySelectorAll('.fel-v2 .opt[data-scope]').forEach(function(el) {
      el.classList.toggle('checked', el.getAttribute('data-scope') === scope);
    });
    refreshFeeLabels();
    recompute();
  }

  function selectTier(tier) {
    state.des.type = tier;
    document.querySelectorAll('.fel-v2 .opt[data-tier]').forEach(function(el) {
      el.classList.toggle('checked', el.getAttribute('data-tier') === tier);
    });
    document.querySelectorAll('.fel-v2 .tier-opt[data-tier]').forEach(function(el) {
      el.classList.toggle('checked', el.getAttribute('data-tier') === tier);
    });
    refreshCtaCopy();
    refreshIntakeImage();
    recompute();
  }

  // "What's included" disclosure under each tier option (Q3)
  var INCL_IDS = { suite: 'inclSuite', indiv: 'inclIndiv', bespoke: 'inclBespoke' };
  function toggleIncl(tier, btn) {
    var el = document.getElementById(INCL_IDS[tier]);
    if (!el) return;
    el.hidden = !el.hidden;
    if (btn) {
      btn.setAttribute('aria-expanded', el.hidden ? 'false' : 'true');
      btn.classList.toggle('open', !el.hidden);
    }
  }

  function refreshFeeLabels() {
    // Tier "from $X" Design Fee shown in tier copy, reactive to scope.
    var scope = state.selectedCategory;
    if (!scope || !window.FEL_PRICING) return;
    var setFee = function(tier, sel) {
      var el = document.querySelector('.fel-v2 .' + sel);
      if (el) el.textContent = window.FEL_PRICING.getDesignFee(scope, tier);
    };
    setFee('suite',   'dep-suite');
    setFee('indiv',   'dep-indiv');
    setFee('bespoke', 'dep-bespoke');
  }

  // ── Scope copy ────────────────────────────────────────────────
  var SCOPE_LABELS = {
    'full':    'Includes save the dates, invitations and essential on-the-day pieces.',
    'inv-std': 'Includes invitations with info cards and envelopes.',
    'otd':     'Includes menus, seating chart, welcome sign and table numbers.'
  };

  // Browsers restore form values after DOMContentLoaded (and on back/forward),
  // leaving state.guestCount empty while the input visibly shows a number.
  // Sync from the DOM whenever state is empty so scope/tier clicks always work.
  function syncGuestsFromInput() {
    if (state.guestCount) return;
    var el = document.getElementById('bpGuestCount');
    if (el && el.value) {
      state.guestCount = String(el.value).replace(/[^0-9]/g, '');
      var n = parseInt(state.guestCount, 10) || 0;
      var hint = document.getElementById('bpInviteHint');
      if (hint) hint.textContent = n > 0 ? ' · ~' + Math.ceil(n * 0.6) + ' invitations' : '';
    }
  }

  // ── Range box / CTA box ───────────────────────────────────────
  function recompute() {
    syncGuestsFromInput();
    var hasGuests = (parseInt(state.guestCount, 10) || 0) > 0;
    var hasScope = !!state.selectedCategory;
    var hasTier = !!state.des.type;
    var rangeBox = document.getElementById('rangeBox');
    var rangeEmpty = document.getElementById('rangeEmpty');
    var actions = document.getElementById('actionsBox');

    if (!(hasGuests && hasScope && hasTier)) {
      if (rangeBox) rangeBox.hidden = true;
      if (rangeEmpty) rangeEmpty.hidden = false;
      if (actions) actions.hidden = true;
      return;
    }

    var est = window.FEL_PRICING && window.FEL_PRICING.computeQuickEstimate(
      state.selectedCategory, state.des.type, state.guestCount
    );
    if (!est) return;

    var anchorEl = document.getElementById('rangeAnchor');
    var loEl = document.getElementById('rangeLo');
    var hiEl = document.getElementById('rangeHi');
    var scopeLabelEl = document.getElementById('rangeScopeLabel');
    if (anchorEl) anchorEl.textContent = fmt0(est.anchor);
    if (loEl) loEl.textContent = fmt0(est.lo);
    if (hiEl) hiEl.textContent = fmt0(est.hi);
    if (scopeLabelEl) scopeLabelEl.textContent = SCOPE_LABELS[state.selectedCategory] || '';

    if (rangeBox) rangeBox.hidden = false;
    if (rangeEmpty) rangeEmpty.hidden = true;
    if (actions) actions.hidden = false;
    refreshCtaCopy();
  }

  function refreshCtaCopy() {
    var isBespoke = state.des.type === 'bespoke';
    var primaryBtn = document.getElementById('primaryCta');
    var primaryLabel = document.getElementById('primaryCtaLabel');
    var saveLink = document.getElementById('saveForLaterLink');

    if (isBespoke) {
      if (primaryLabel) primaryLabel.textContent = 'Begin your bespoke conversation →';
      if (primaryBtn) primaryBtn.setAttribute('data-action', 'bespoke');
      if (saveLink) saveLink.hidden = true;
    } else {
      if (primaryLabel) primaryLabel.textContent = 'Build your suite →';
      if (primaryBtn) primaryBtn.setAttribute('data-action', 'build');
      if (saveLink) saveLink.hidden = false;
    }
  }

  function applyDirectEntry() {
    var note = document.getElementById('directEntryNote');
    var tierField = document.getElementById('tierField');
    if (!state.des.fromUrl || !state.des.type) {
      if (note) note.hidden = true;
      if (tierField) tierField.hidden = false;
      return;
    }
    if (tierField) tierField.hidden = true;
    if (note) {
      note.hidden = false;
      var TIER_LABELS = { suite: 'Studio Collection', indiv: 'Tailored Touch', bespoke: 'Bespoke' };
      var nm = state.des.designName || 'Your suite';
      var tn = TIER_LABELS[state.des.type] || '';
      var nmEl = document.getElementById('directName');
      var tnEl = document.getElementById('directTier');
      if (nmEl) nmEl.textContent = nm;
      if (tnEl) tnEl.textContent = tn;
    }
  }

  // ── Actions ───────────────────────────────────────────────────
  function onPrimaryCta() {
    var action = document.getElementById('primaryCta').getAttribute('data-action');
    if (action === 'bespoke') return goBespokePage();
    return openFullQuote();
  }

  function goBespokePage() {
    // TODO: repoint to /pages/bespoke once built. Current live Bespoke enquiry destination:
    window.location.href = '/products/bespoke-design';
  }

  function openFullQuote() {
    // Toggle Full UI on the SAME URL via ?mode=full. Carries state for Full to hydrate.
    var params = new URLSearchParams(window.location.search);
    params.set('mode', 'full');
    if (state.guestCount) params.set('guests', state.guestCount);
    if (state.selectedCategory) params.set('scope', state.selectedCategory);
    if (state.des.type && state.des.type !== 'bespoke') params.set('tier', state.des.type);
    window.location.href = window.location.pathname + '?' + params.toString();
  }

  function openBookCall(e) {
    if (e) e.preventDefault();
    window.open('https://felicitations.com.au/pages/wedding-stationery-consultation', '_blank', 'noopener');
  }

  function changeSuite(e) {
    if (e) e.preventDefault();
    // TODO: repoint bespoke to /pages/bespoke once built.
    // indiv → live TT product (the /pages/tailored-touch draft was deleted 3 Jul; TT page consolidation lands later as custom-wedding-invitations-australia).
    var URLS = { suite: '/collections/studio-collection', indiv: '/products/tailored-touch', bespoke: '/products/bespoke-design' };
    window.location.href = URLS[state.des.type] || '/collections/studio-collection';
  }

  function saveForLater(e) {
    if (e) e.preventDefault();
    // Placeholder for email opt-in modal - wires to Shopify customer API
    // via existing Netlify /apps/quote/customer endpoint (next phase).
    alert(
      'Save for later (placeholder):\n\n' +
      'This opens a small modal:\n' +
      '· Email field\n' +
      '· "Send me this estimate + design inspiration occasionally"\n' +
      '· Submits to Shopify customer record (Netlify /apps/quote/customer)\n\n' +
      'No-friction opt-in - value exchange (saved estimate) for email. Per Masha: only opt-in moments, never gate.'
    );
  }

  window.FEL_V2.onGuestInput = onGuestInput;
  window.FEL_V2.selectScope = selectScope;
  window.FEL_V2.selectTier = selectTier;
  window.FEL_V2.toggleIncl = toggleIncl;
  window.FEL_V2.onPrimaryCta = onPrimaryCta;
  window.FEL_V2.openBookCall = openBookCall;
  window.FEL_V2.changeSuite = changeSuite;
  window.FEL_V2.saveForLater = saveForLater;

  document.addEventListener('DOMContentLoaded', function() {
    // If ?mode=full present, hide Quick entirely (Full takes over on same URL).
    var mode = new URLSearchParams(window.location.search).get('mode');
    if (mode === 'full') {
      var quickRoot = document.querySelector('.fel-v2');
      if (quickRoot) quickRoot.style.display = 'none';
      return;
    }

    readUrlParams();
    applyDirectEntry();

    // Empty-state helper copy reflects how many questions are actually visible
    // (direct entry hides Q3, so user only has 2 questions to answer).
    var helperEl = document.getElementById('estHelper');
    if (helperEl) {
      var nLabel = state.des.fromUrl ? 'two' : 'three';
      helperEl.innerHTML = '<em>Answer the ' + nLabel + ' questions to see your range.</em>';
    }

    // Hydrate guest count from browser-persisted input (after refresh, the input
    // value sticks via autofill but state.guestCount is empty - sync them).
    var guestsEl = document.getElementById('bpGuestCount');
    if (guestsEl && guestsEl.value && !state.guestCount) {
      onGuestInput(guestsEl.value);
    }

    if (state.des.type) selectTier(state.des.type);
    refreshFeeLabels();
    refreshIntakeImage();
    recompute();

    window.addEventListener('pageshow', function() {
      syncGuestsFromInput();
      recompute();
    });
  });
})();
